const Partner = () => {
  return (
    <div className="w-full h-screen">
      <iframe 
        src="https://unequaled-engine-3ab.notion.site/ebd/1580a75a9cdf8055aa7de5da547445ca" 
        width="100%" 
        height="100%" 
        frameBorder="0" 
        allowFullScreen 
      />
    </div>
  );
};

export default Partner;
